<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q3UrdP/tc-custom/9781250173911.jpg?1731883415231" alt="This image is the cover for the book Cut to the Bone, Agent Sayer Altair"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cut to the Bone, Agent Sayer Altair
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In Ellison Cooper's new standalone novel <i>Cut to the Bone</i>, a bus full of high school students has disappeared from Washington D.C. and FBI neuroscientist Sayer Altair must hunt down the culprit who has a link to her own past.</b><br/><br/>After grieving the death of her fiancé and almost losing her job, Agent Sayer Altair is finally starting to rebuild her life. Her research into the minds of psychopaths is breaking new ground and her strange little family is thriving. But Sayer’s newfound happiness is threatened when she is called in to investigate a girl’s body left inside a circle of animal figurines below a cryptic message written in blood. When they discover that the dead girl is one of twenty-four missing high school students, Sayer quickly realizes that nothing in this case is what it seems.<br/><br/>As the investigation draws her in to a tangled web of fake identities and false leads, the trail soon begins to point directly to her own life. Now, Sayer must confront her painful past to uncover her connection to the deranged killer if she hopes to save the missing teens and protect everything that she loves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellison Cooper
      </h2>
      
      <p class="authorDescription body article"><B>ELLISON COOPER</B> has a Ph.D. in anthropology from UCLA, with a background in archaeology, cultural neuroscience, ancient religion, colonialism, and human rights. She has conducted fieldwork in Central America, West Africa, Micronesia, and Western Europe. She has worked as a murder investigator in Washington DC, and is a certified K9 Search and Rescue Federal Disaster Worker. She now lives in the Bay Area with her husband and son. Ellison is the author of <I>Caged</I>, <I>Buried</I>, and <I>Cut to the Bone</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c95379c